import { NavLink } from "react-router-dom";
import Navbar from "react-bootstrap/Navbar";
import { Container, Nav, Button } from "react-bootstrap";
import logo from "../../assets/logo.png";

function Header() {
  return (
    <Navbar expand="lg" fixed="top" className="site-navbar px-2 py-2">
      <Container>
        <Navbar.Brand
          as={NavLink}
          to="/"
          className="d-flex align-items-center gap-2 fw-bold text-dark"
        >
          <img src={logo} alt="CodeCamp Logo" style={{ width: 44 }} />
          <span>CodeCamp</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="main-nav" />
        <Navbar.Collapse id="main-nav">
          <Nav className="mx-auto">
            <NavLink className="nav-link" to="/">
              Home
            </NavLink>
            <NavLink className="nav-link" to="/services">
              Services
            </NavLink>
            <NavLink className="nav-link" to="/solutions">
              Solutions
            </NavLink>
            <NavLink className="nav-link" to="/portfolio">
              Portfolio
            </NavLink>
            <NavLink className="nav-link" to="/about">
              About
            </NavLink>
            <NavLink className="nav-link" to="/contact">
              Contact
            </NavLink>
          </Nav>
          <Nav>
            <Button
              as={NavLink}
              to="/contact"
              variant="primary"
              className="rounded-pill px-3"
            >
              Book a Free Consultation
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
